import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./UniquePatientMonitored.scss";

function UniquePatientMonitored({ tiles, dateRangeDisplay }) {
  return (
    <div className="unique-patient-card">
      <div className="unique-patient-header">
        <div className="header-left">
          <h3 className="stats-title">Unique Patient monitored</h3>
          <p className="stats-subtitle">By number of recordings taken</p>
        </div>
        {dateRangeDisplay && (
          <div className="date-inline-display">
            <CalendarMonthIcon className="calendar-icon" />
            {dateRangeDisplay}
          </div>
        )}
      </div>

      <div className="unique-patient-tiles">
        {tiles.map((tile) => (
          <div className="unique-patient-tile" key={tile.label}>
            <div className="tile-percentage">{tile.percentage}</div>
            <div className="tile-label">{tile.label}</div>
            <div className="tile-count">{tile.count} Pregnant Women</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UniquePatientMonitored;
